"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Regex = exports.RegexTest = void 0;
var RegexTest = (function () {
    function RegexTest() {
    }
    RegexTest.isoDate = function (string) {
        return string.match(exports.Regex.ISO_DATE) != null || string.match(exports.Regex.DATE);
    };
    return RegexTest;
}());
exports.RegexTest = RegexTest;
exports.Regex = {
    is: RegexTest,
    ISO_DATE_RUBY: /^[0-9]{4}-[0-9]{2}-[0-9]{2}T([0-9]{2}:){2}[0-9]{2}\.[0-9]{3}[+|-][0-9]{2}:[0-9]{2}$/,
    ISO_DATE: /^(\d{4}-\d{2}-\d{2})[A-Z]+(\d{2}:\d{2}:\d{2}).([0-9+-:]+)Z?$/,
    DATE: /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/
};
//# sourceMappingURL=Regex.js.map